namespace $ {
	/** Exact stored-unit state, without loading/decrypting row payloads. */
	export class $shm_hitalama_map_widget_entity_table2_querysnapshot_signature extends $mol_object {
		@ $mol_mem_key
		subtree( key: readonly [ $giper_baza_land, string ] ): string | null {
			const [ land, root ] = key
			land.sync()
			land.sand_encoding()
			land.secret()
			if( land._sand.has( $giper_baza_land_root.tine.str ) ) return null
			const visited = new Set<string>()
			const queue = [ root ]
			const hashes: string[] = []
			for( const head of queue ) {
				if( visited.has( head ) ) continue
				visited.add( head )
				for( const peers of land._sand.get( head )?.values() ?? [] ) for( const sand of peers.values() ) {
					if( !sand.encoded() ) return null
					hashes.push( sand.hash().str )
					if( sand.self().str ) queue.push( sand.self().str )
				}
			}
			return $giper_baza_link.hash_str( JSON.stringify([ land.link().str, root, hashes.sort() ]) ).str
		}

		@ $mol_mem_key
		read( key: readonly [ $giper_baza_land, string ] ): string | null {
			const [ land, root ] = key
			land.sync()
			land.sand_encoding()
			if( land.pass_rank( land.auth().pass() ) < $giper_baza_rank_read ) throw new Error( 'Нет доступа к данным снимка запросов' )
			land.secret()
			if( land._sand.has( $giper_baza_land_root.tine.str ) ) return null
			const excluded = new Set<string>()
			const queue = root ? [ root ] : []
			for( const head of queue ) {
				if( excluded.has( head ) ) continue
				excluded.add( head )
				for( const peers of land._sand.get( head )?.values() ?? [] ) for( const sand of peers.values() ) {
					if( sand.self().str ) queue.push( sand.self().str )
				}
			}
			const hashes: string[] = []
			for( const gift of land._gift.values() ) hashes.push( gift.hash().str )
			for( const [ head, peers ] of land._sand ) {
				if( excluded.has( head ) ) continue
				for( const sands of peers.values() ) for( const sand of sands.values() ) {
					if( !sand.encoded() ) return null
					hashes.push( sand.hash().str )
				}
			}
			return $giper_baza_link.hash_str( JSON.stringify([ land.link().str, hashes.sort() ]) ).str
		}
	}
}
